import { BaseViewModel } from "@iot-platform/core";
import { injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class StationAlertViewmodel extends BaseViewModel {
    @observable
    initialLoading = false;

    @observable
    showAddPredefinedAlertModal = false;

    constructor() {
        super();
        makeObservable(this);
    }

    override didMount(): void {
        this.initViewData();
    }

    initViewData(): void {
        runInAction(() => {
            this.initialLoading = false;
        });
    }

    @action
    toggleShowAddPredefinedAlertModal(): void {
        this.showAddPredefinedAlertModal = !this.showAddPredefinedAlertModal;
    }
}
